import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export default function WhatsAppFab() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "whatsapp_click", source: "floating_button" });
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", { send_to: "AW-16867023480/7Cp6CKy784ocEPi06eo-" });
    }
  };

  return (
    <a
      href={SITE.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label="WhatsApp"
      data-testid="whatsapp-fab"
      data-conversion="whatsapp_click"
      className={`fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-[#faf6ef] border border-black/10 text-[#25D366] inline-flex items-center justify-center hover:border-[#25D366]/60 hover:bg-[#f0f1f4] transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <MessageCircle className="w-5 h-5" strokeWidth={2} />
    </a>
  );
}
